import type { Composer } from 'vue-i18n'

type LibraryMessages = Record<string, object>

const libraries = Object.values(
  import.meta.glob<{ default: LibraryMessages }>('/node_modules/@tsyl/*/lib/language/index.js', { eager: true })
).map((library) => library.default)

// The libraries ship fr-CA and pt-PT, and zapan2 has no French at all; the first locale found wins and the global
// fallbackLocale covers the rest.
const SOURCE_LOCALES: Record<string, string[]> = {
  'en-US': ['en-US'],
  'es-ES': ['es-ES'],
  'fr-FR': ['fr-FR', 'fr-CA'],
  'pt-BR': ['pt-BR', 'pt-PT']
}

export function mergeLibraryLocales(i18n: Pick<Composer, 'mergeLocaleMessage'>, messages: LibraryMessages[] = libraries) {
  for (const library of messages) {
    for (const [locale, sources] of Object.entries(SOURCE_LOCALES)) {
      const source = sources.find((candidate) => candidate in library)
      if (source) i18n.mergeLocaleMessage(locale, library[source])
    }
  }
}
